// src/components/forms/shared/SelectField.jsx
import React from 'react';

export const SelectField = ({ 
  id, 
  label, 
  required = false, 
  icon, 
  value, 
  onChange, 
  options,
  error,
  validate,
  onBlur
}) => {
  const handleBlur = (e) => {
    if (validate) {
      validate(e.target.value);
    }
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <div className="relative">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="mt-1 relative rounded-md shadow-sm">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
        <select
          id={id}
          name={id}
          required={required}
          className={`${
            icon ? 'pl-10' : 'pl-3'
          } block w-full sm:text-sm border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 ${
            error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : ''
          }`}
          value={value || ''}
          onChange={onChange}
          onBlur={handleBlur}
        >
          <option value="">Select {label}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

// export const SelectField = ({ 
//   id, 
//   label, 
//   icon,
//   required = false,
//   value,
//   onChange,
//   options,
//   ...props 
// }) => {
//   return (
//     <div>
//       <label htmlFor={id} className="block text-sm font-medium text-gray-700">
//         {label}
//       </label>
//       <div className="mt-1 relative">
//         {icon && (
//           <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//             {icon}
//           </div>
//         )}
//         <select
//           id={id}
//           required={required}
//           className="appearance-none block w-full pl-10 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//           value={value}
//           onChange={onChange}
//           {...props}
//         >
//           <option value="">Select {label}</option>
//           {options.map(option => (
//             <option key={option.value} value={option.value}>
//               {option.label}
//             </option>
//           ))}
//         </select>
//       </div>
//     </div>
//   );
// };

// export default SelectField;